module.exports = __webpack_public_path__ + "static/img/stay-option-icon-toothpaste.f361dc35.svg";